/**
 * Elements Index
 * 
 * This file exports all element components for easy importing in other files.
 * Direct exports of MUI components following the direct integration approach.
 * 
 * Note: All wrapper components (e.g., AudioPlayerWrapper.js, CeilingWrapper.js) have been removed
 * as part of the migration to the direct integration approach. These wrapper components
 * were previously used with feature flags to conditionally render either the original
 * or MUI components, but are no longer needed with the direct export approach.
 */

import MuiAudioPlayer from './MuiAudioPlayer';
import MuiLineDimension from './MuiLineDimension';
import MuiDoor from './MuiDoor';
import MuiFloorplan from './MuiFloorplan';
import MuiRoof from './MuiRoof';
import MuiRoofGrid from './MuiRoofGrid';
import MuiStorage from './MuiStorage';
import { muiStorageElements } from './MuiStorageElements';
import MuiOverlaps from './MuiOverlaps';
import MuiCeiling from './MuiCeiling';
import MuiTable from './MuiTable';
import MuiLoadingDocks from './MuiLoadingDocks';
import MuiMeasuringTape from './MuiMeasuringTape';
import MuiCeilingTileCoverage from './MuiCeilingTileCoverage';
import { MuiSpeakers, MuiMicrophones, MuiHorns, MuiCameras } from './MuiDevices';

// Note: Type exports have been removed to simplify the module.
// Consumers can import types directly from 'types/components/elements'

const ElementsIndex = {
  floorplan: MuiFloorplan,
  lineDimension: MuiLineDimension,
  door: MuiDoor,
  ceiling: MuiCeiling,
  table: MuiTable,
  loadingDocks: MuiLoadingDocks,
  roof: MuiRoof,
  roofgrid: MuiRoofGrid,
  storage: MuiStorage,
  storageElements: muiStorageElements,
  overlaps: MuiOverlaps,
  horns: MuiHorns,
  speakers: MuiSpeakers,
  microphones: MuiMicrophones,
  cameras: MuiCameras,
  audioPlayer: MuiAudioPlayer,
  measuringTape: MuiMeasuringTape,
  ceilingTileCoverage: MuiCeilingTileCoverage
};

export default ElementsIndex;
